export const WidgetIcon = ({ active }: { active: boolean }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={26} height={19} fill="none">
        <rect width={25} height={17} x={0.495} y={1} stroke={active ? '#010101' : '#989898'} rx={1.5} />
        <circle cx={19.495} cy={12} r={2.5} fill={active ? '#010101' : '#989898'} />
    </svg>
);
export const FrameIcon = ({ active }: { active: boolean }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={27} height={19} fill="none">
        <rect width={25} height={17} x={1} y={1} stroke={active ? '#010101' : '#989898'} rx={1.5} />
        <mask id="a" fill="#fff">
            <path d="M1.5 3.5h12v12h-12v-12Z" />
        </mask>
        <path fill={active ? '#010101' : '#989898'} d="M1.5 4.5h12v-2h-12v2Zm12 10h-12v2h12v-2Z" mask="url(#a)" />
        <path fill={active ? '#010101' : '#989898'} d="M13.5 3.5h12v12h-12z" />
    </svg>
);
export const RightIcon = ({ active }: { active: boolean }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={72} height={49} fill="none">
        <rect width={70.8} height={46.8} x={0.6} y={1.1} fill="#F3F3F3" rx={6.6} />
        <rect width={70.8} height={46.8} x={0.6} y={1.1} stroke={active ? '#010101' : '#DBDBDB'} strokeWidth={1.2} rx={6.6} />
        <rect width={12} height={12} x={51.6} y={30.5} fill={active ? '#010101' : '#DBDBDB'} rx={3} />
    </svg>
);
export const LeftIcon = ({ active }: { active: boolean }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={72} height={49} fill="none">
        <rect width={70.8} height={46.8} x={0.6} y={1.1} fill="#F3F3F3" rx={6.6} />
        <rect width={70.8} height={46.8} x={0.6} y={1.1} stroke={active ? '#010101' : '#DBDBDB'} strokeWidth={1.2} rx={6.6} />
        <rect width={12} height={12} x={8.4} y={30.5} fill={active ? '#010101' : '#DBDBDB'} rx={3} />
    </svg>
);
export const MobileIcon = ({ active }: { active: boolean }) => (
    <svg width="18" height="30" viewBox="0 0 18 30" opacity={active ? 1 : 0.3} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_58949_15575)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.31002 3.29922C3.39352 3.29922 2.75002 3.99472 2.75002 4.73572V25.2627C2.75002 25.6436 2.91902 26.0115 3.20762 26.2806C3.48062 26.5341 3.86282 26.6992 4.31002 26.6992H12.89C13.8065 26.6992 14.45 26.0037 14.45 25.2627V4.73572C14.45 3.99472 13.8065 3.29922 12.89 3.29922H4.31002ZM0.150024 4.73572C0.150024 3.28882 0.922224 2.05512 2.05842 1.34402C2.73354 0.921977 3.51384 0.69852 4.31002 0.69922H12.89C15.1325 0.69922 17.05 2.45422 17.05 4.73572V25.2627C17.05 27.5442 15.1325 29.2992 12.89 29.2992H4.31002C2.06752 29.2992 0.150024 27.5442 0.150024 25.2627V4.73572ZM10.4395 22.7966C10.3047 23.1769 10.0555 23.5062 9.7262 23.7394C9.39689 23.9726 9.00354 24.0983 8.60002 24.0992C8.18621 24.0992 7.78313 23.9675 7.44909 23.7233C7.11506 23.479 6.86739 23.1348 6.74192 22.7405C6.61645 22.3461 6.61968 21.9221 6.75115 21.5297C6.88261 21.1373 7.1355 20.797 7.47321 20.5578C7.81093 20.3187 8.21597 20.1932 8.62974 20.1994C9.04351 20.2057 9.44455 20.3435 9.77485 20.5928C10.1051 20.8421 10.3476 21.19 10.4671 21.5862C10.5866 21.9823 10.5769 22.4063 10.4395 22.7966ZM5.35002 4.59922C5.00524 4.59922 4.67458 4.73618 4.43079 4.97998C4.18699 5.22378 4.05002 5.55444 4.05002 5.89922C4.05002 6.244 4.18699 6.57466 4.43079 6.81846C4.67458 7.06226 5.00524 7.19922 5.35002 7.19922H11.85C12.1948 7.19922 12.5255 7.06226 12.7693 6.81846C13.0131 6.57466 13.15 6.244 13.15 5.89922C13.15 5.55444 13.0131 5.22378 12.7693 4.97998C12.5255 4.73618 12.1948 4.59922 11.85 4.59922H5.35002Z"
                fill="#111"
            />
        </g>
        <defs>
            <clipPath id="clip0_58949_15575">
                <rect width="16.9" height="28.6" fill="white" transform="translate(0.150024 0.699219)" />
            </clipPath>
        </defs>
    </svg>
);
export const DesktopIcon = ({ active }: { active: boolean }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={35} height={28} fill="none" opacity={active ? 1 : 0.3}>
        <g clipPath="url(#a)">
            <path
                fill="#111"
                fillRule="evenodd"
                d="M3.427 3.84c0-.29.364-.888 1.3-.888h26c.529 0 .877.192 1.079.413.152.169.22.351.22.476v16.421c0 .29-.363.89-1.3.89h-26c-.463 0-.787-.147-.996-.33-.211-.188-.303-.414-.303-.56V3.841Zm1.3-3.488c-1.937 0-3.9 1.36-3.9 3.489v16.421c0 1.5.972 2.616 2.223 3.146a4.323 4.323 0 0 0 1.677.344h26c1.937 0 3.9-1.361 3.9-3.49V3.841c0-2.128-1.963-3.49-3.9-3.49h-26Zm2.796 25.314a1.3 1.3 0 0 0 1.104 1.986h18.2a1.3 1.3 0 0 0 0-2.6h-18.2a1.297 1.297 0 0 0-1.104.614Z"
                clipRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M.827.352h33.8v27.3H.827z" />
            </clipPath>
        </defs>
    </svg>
);
